import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProductCard from "./ProductCard";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SearchPage() {
  const query = useQuery().get("q");
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!query) return;

    fetch(`https://api.monkeye.in/api/search?q=${query}`)
      .then(res => res.json())
      .then(setProducts);
  }, [query]);

return (
  <div style={{ padding: 20 }}>
    <h2>
      Results for "{query}" ({products.length})
    </h2>

    {products.length === 0 ? (
      <p>No results found. Try different keywords.</p>
    ) : (
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: "16px",
        marginTop: "20px"
      }}>
        {products.map(p => (
          <ProductCard key={p._id} product={p} />
        ))}
      </div>
    )}
  </div>
);
}